import { render, staticRenderFns } from "./TrustedDeviceMixin.vue?vue&type=template&id=988b24fc&scoped=true"
import script from "./TrustedDeviceMixin.vue?vue&type=script&lang=js"
export * from "./TrustedDeviceMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988b24fc",
  null
  
)

export default component.exports